module.exports = __webpack_public_path__ + "static/media/Savage_Main.a1a9c0be.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Savage_Main.webp
// module id = ./src/assets/Savage_Main.webp
// module chunks = 0